import { useAbGroup } from '@/app/providers/ConfigProvider';
import { isUserInAmountBasedTipOptions } from '@/app/utils/abTesting/checkout-form';

export const useIsUserInAmountBasedTipOptions = () => {
  const abGroup = useAbGroup();

  return isUserInAmountBasedTipOptions(abGroup);
};
